import { useEffect, useState } from 'react';
import useFunLinkPageData from '../use-fun-link-page-data';

export function useLayerData(key, defaultValue = null) {
  const [layerData, setLayerData] = useState(defaultValue);
  const pageData = useFunLinkPageData();

  useEffect(
    () => {
      const data = pageData?.[key];
      data && setLayerData(data);
      // console.log('useLayerData', key, data);
    },
    [pageData]
  );

  return layerData;
}
